import { all } from 'redux-saga/effects'
import { postingSagas } from './posting/posting.sagas'
import { facebookSagas } from './facebook/facebook.sagas'
import { googleMyBusinessSagas } from './googleMyBusiness/googleMyBusiness.sagas'
import { instagramSagas } from './instagram/instagram.sagas'
import { commonSagas } from './common/common.sagas'
import { linkedInSagas } from './linkedIn/linkedIn.sagas'

export function * postingRootSagas () {
  yield all([
    postingSagas(),
    facebookSagas(),
    instagramSagas(),
    commonSagas(),
    googleMyBusinessSagas(),
    linkedInSagas()
  ])
}
